import { render, staticRenderFns } from "./_StoreGoodsPopup.vue?vue&type=template&id=0ca40f94&"
import script from "./_StoreGoodsPopup.vue?vue&type=script&lang=js&"
export * from "./_StoreGoodsPopup.vue?vue&type=script&lang=js&"
import style0 from "./_StoreGoodsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports